import { ICalendarSetting } from '@app-types/websocket/user.types';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';

export function getForwardingEmailAddress(session: any, settings: ICalendarSetting): string | null | undefined {
  if (settings.accountId !== session?.data?.id || settings.familyId !== getSelectedFamilyResource(session)?.id) {
    return undefined;
  }
  const token = settings.emailToken;
  if (token === null || token === undefined) { return token; }
  return typeof token === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(token)
    ? `${token}@data.co-parenting.app` : '';
}

export function getSelectedFamilyResource(session: any): any | undefined {
  const resources:any[] = Array.isArray(session?.data?.resources)
    ? session.data.resources
    : [];
  const selectedFamilyIndex:number = Number.isInteger(session?.selectedFamily)
    ? session.selectedFamily
    : 0;

  if (selectedFamilyIndex >= 0 && selectedFamilyIndex < resources.length) {
    return resources[selectedFamilyIndex];
  }

  return resources[0];
}

/**
 * The parent whose weeks the calendar shows, or undefined for everyone's. Parents can only
 * pick themselves and important adults one of the parents; anything else shows all weeks.
 */
export function getOnlyWeeksOf(state: any): number | undefined {
  const parentId = state?.user?.calendarSettings?.onlyWeeksOf;
  if (typeof parentId !== 'number' || parentId <= 0) { return undefined; }
  const userId = state?.user?.session?.data?.id;
  const family: IFamilyMember[] = Array.isArray(state?.family?.family) ? state.family.family : [];
  const me = family.find((mem) => mem.id === userId);
  const parent = family.find((mem) => mem.id === parentId && mem.role === FamilyMemberType.PARENT);
  if (!me || !parent) { return undefined; }
  if (me.role === FamilyMemberType.PARENT) { return parentId === userId ? parentId : undefined; }
  return me.role === FamilyMemberType.VIEWER ? parentId : undefined;
}

export function hasAuthToken(state: any): boolean {
  const auth = state?.user?.session?.data?.authorization;
  return typeof auth === 'string' && auth.length > 0;
}



// WEBPACK FOOTER //
// ./src/services/user/user.utils.ts